export default __webpack_public_path__ + "static/media/window.010975d7.svg";